import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M13.5 13.48l-4-4L2 16.99l1.5 1.5 6-6.01 4 4L22 6.92l-1.41-1.41z"
}), 'ShowChartTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ShowChartTwoTone.js
// module id = 6122
// module chunks = 2